import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobCompany, deleteJobCompany, fetchJobCompanyList, updateJobCompany } from "./JobCompanyListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobCompanyListAsync = createAsyncThunk(
  "jobCompanyList/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobCompanyList();

      const resp = data?.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteJobCompanyAsync = createAsyncThunk(
  'jobCompanyList/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobCompany(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateJobCompanyAsync = createAsyncThunk(
  'jobCompanyList/update',
  async ({ uuid, jobTitleData }, { rejectWithValue }) => {
    try {
      const response = await updateJobCompany(uuid, jobTitleData);
      console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobCompanyAsync = createAsyncThunk(
  "jobCompanyList/add",
  async (newJobTitle) => {
    try {
      const data = await addJobCompany(newJobTitle);
      console.log("data in slice", data)
      return data;
    } catch (error) {
      console.log("errorL :" , error)
      // return rejectWithValue(error.message);
    }
  }
);

const jobCompanySlice = createSlice({
  name: "jobCompany",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobCompanyListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobCompanyListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobCompanyListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addJobCompanyAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobCompanyAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateJobCompanyAsync.pending, (state) => {
        state.loading = true;
        console.log("Loading")
        state.error = null;
      })
      .addCase(updateJobCompanyAsync.fulfilled, (state, action) => {
        state.loading = false;
        console.log("data", state.data)
        state.data = state.data.map((jobCompany) =>
          jobCompany.uuid === action.payload.uuid ? action.payload : jobCompany
        );
      })
      .addCase(updateJobCompanyAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteJobCompanyAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobCompanyAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (jobCompany) => jobCompany.uuid !== action.payload
        );
      })
      .addCase(deleteJobCompanyAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectJobCompany = (state) => state.jobCompanyList.data;

export default jobCompanySlice.reducer;
